import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { type LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export interface SalesCoachingCohortMember {
	userId: string;
	/** Normalized cohort name; null when the rep is in no cohort. */
	cohort?: string | null;
	assignedById?: string | null;
	assignedDate?: string | null;
}

const BASE_QUERY_KEY = 'AISalesCoaching/cohorts';

export function useSalesCoachingCohortsQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	const accountId = userSession.account?.id;

	return useQuery({
		queryKey: [BASE_QUERY_KEY, accountId],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<SalesCoachingCohortMember[]>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: 'AISalesCoaching/cohorts' }),
				'GET'
			),
		enabled,
		staleTime: 5 * 60_000,
		meta: {
			toastErrorMessage: 'Failed to load coaching cohorts',
			errorLogging: { category: 'AICoachingReview', action: 'loadSalesCoachingCohorts' },
		} satisfies LevStandardQueryMeta,
	});
}

export function invalidateSalesCoachingCohortsQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
